import { render, staticRenderFns } from "./WeeklyCalendar.vue?vue&type=template&id=05736db7&scoped=true&"
import script from "./WeeklyCalendar.vue?vue&type=script&lang=js&"
export * from "./WeeklyCalendar.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyCalendar.vue?vue&type=style&index=0&id=05736db7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05736db7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VRow,VSelect})
